// src/components/common/Pagination.jsx
import React from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

export default function Pagination({
  total,          // 전체 데이터 개수
  pageNum,        // 현재 페이지 번호
  pageSize,       // 페이지당 데이터 개수
  onChange,       // 페이지 변경 시 실행될 함수
  itemName = "데이터" // 하단에 표시될 아이템 이름 (기본값: 데이터)
}) {
  // 1. 전체 페이지 수 계산 (데이터가 0개여도 최소 1페이지는 표시)
  const totalPages = Math.max(1, Math.ceil(total / pageSize));

  // 2. 화면에 보여줄 최대 페이지 버튼 수 (예: 5개)
  const maxButtons = 5;
  
  // 3. 시작 페이지와 끝 페이지 계산
  let startPage = Math.max(1, pageNum - Math.floor(maxButtons / 2));
  let endPage = startPage + maxButtons - 1;

  // 끝 페이지가 전체 페이지 수를 넘어가면 조정
  if (endPage > totalPages) {
    endPage = totalPages;
    startPage = Math.max(1, endPage - maxButtons + 1);
  }

  // 화면에 그릴 페이지 배열 생성 (예: [1, 2, 3, 4, 5])
  const pages = [];
  for (let i = startPage; i <= endPage; i++) {
    pages.push(i);
  }

  return (
    <div className="flex items-center justify-between border-t border-slate-200 bg-white px-6 py-4">
      {/* 왼쪽: 총 개수 표시 */}
      <div className="text-sm text-slate-500">
        총 <span className="font-bold text-slate-900">{total}</span>개의 {itemName}
      </div>

      {/* 오른쪽: 페이지네이션 버튼 컨트롤 */}
      <div className="flex items-center gap-1">
        {/* 이전 버튼 */}
        <button
          disabled={pageNum === 1}
          onClick={() => onChange(Math.max(1, pageNum - 1))}
          className="flex h-8 items-center gap-1 rounded border border-slate-200 px-3 text-sm text-slate-600 hover:bg-slate-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
        >
          <ChevronLeft className="h-4 w-4" /> 이전
        </button>

        {/* 숫자 버튼들 */}
        <div className="mx-2 flex items-center gap-1">
          {pages.map((p) => (
            <button
              key={p}
              onClick={() => onChange(p)}
              className={`flex h-8 w-8 items-center justify-center rounded text-sm font-medium transition-colors ${
                p === pageNum
                  ? "bg-blue-600 text-white shadow-sm" // 현재 페이지 스타일
                  : "text-slate-600 hover:bg-slate-100 border border-transparent hover:border-slate-200" // 기본 스타일
              }`}
            >
              {p}
            </button>
          ))}
        </div>

        {/* 다음 버튼 */}
        <button
          disabled={pageNum >= totalPages}
          onClick={() => onChange(Math.min(totalPages, pageNum + 1))}
          className="flex h-8 items-center gap-1 rounded border border-slate-200 px-3 text-sm text-slate-600 hover:bg-slate-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
        >
          다음 <ChevronRight className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}